<template>
    <v-layout class="my-4 border d-block">
        <preferred-communication-error
            :visible="preferredCommunicationError"
            @closeDialog="closeDialog"
        />
        <div class="pa-2 d-flex">
            <v-checkbox
                class="body-2"
                :input-value="computedValue"
                :rules="[
                    !required || requiredField()
                ]"
                :name="metadata.name"
                :data-meta-id="metadata.id"
                :id="metadata.name"
                @change="emitValue"
            >
                <template slot="label">
                    <u
                        class="font-weight-bold"
                        v-html="acceptText" />
                </template>
            </v-checkbox>
            <v-icon
                class="more-info-chevron"
                data-testid="moreIcon"
                @click="toggleFullText"
                v-html="showChevron" />
        </div>
        <div v-if="showFullText" class="px-3 pb-3 text--light--form">
            <span v-html="consentText" />
        </div>
    </v-layout>
</template>

<script>
import { formRules } from '@/mixins/form-rules';
import { mapGetters } from 'vuex';
import { find } from 'lodash';
import { MetadataEnum } from '@/enums';
import PreferredCommunicationError from '@/components/metadata/dialogs/PreferredCommunicationError';

export default {
    name: 'covid-screening-consent-receive-result-by-email-sms',
    components: { PreferredCommunicationError },
    mixins: [formRules],
    props: {
        metadata: { type: Object, required: true },
        otherMetadata: { type: Array, required: true },
        outline: { type: Boolean, required: false, default: false },
        required: { type: Boolean, required: false, default: false },
        value: { type: [String, Boolean, Number], required: false, default: '' },
    },
    data() {
        return {
            originalEmailMetadata: {},
            preferredCommunicationError: false,
            showFullText: false,
        };
    },
    computed: {
        ...mapGetters({
            upperLocale: 'upperLocale',
        }),
        computedValue() {
            return this.value ? 1 : 0;
        },
        text() {
            return this.$i18n.t('covidScreeningMetadataLang.covidScreeningConsentReceiveResultByEmailSms');
        },
        consentText() {
            return this.text.description;
        },
        acceptText() {
            return this.required ? `* ${this.text.accept}` : this.text.accept;
        },
        showChevron() {
            return this.showFullText ? 'fas fa-chevron-up' : 'fas fa-chevron-down';
        },
        preferredCommunicationEmailOption() {
            return this.$i18n.t('covidScreeningMetadataLang.covidScreeningPreferredCommunication.dropDown')[0];
        },
        preferredCommunicationMetadata() {
            return this.otherMetadata && find(this.otherMetadata, ['metadata', MetadataEnum.COVID_SCREENING_PREFERRED_COMMUNICATION], 0);
        },
        emailMetadata() {
            return this.otherMetadata && find(this.otherMetadata, ['metadata', MetadataEnum.EMAIL], 0);
        },
        emailMetadataValue() {
            return this.emailMetadata ? this.emailMetadata.value : false;
        },
        preferredCommunicationMetadataIsPresentAndSetAsEmail() {
            return this.preferredCommunicationMetadata
                ? this.preferredCommunicationMetadata.value === this.preferredCommunicationEmailOption
                : true;
        },
        covidScreeningConsentReceiveResultByEmailSmsHasError() {
            return !this.preferredCommunicationMetadataIsPresentAndSetAsEmail || !this.emailMetadataValue;
        },
    },
    methods: {
        emitValue(value) {
            this.preferredCommunicationError = this.emailMetadata &&
            value ? this.covidScreeningConsentReceiveResultByEmailSmsHasError : false;
            const findMetaDataEmail = this.otherMetadata && find(this.otherMetadata, ['metadata', MetadataEnum.EMAIL]);
            if (findMetaDataEmail) {
                if (value) {
                    findMetaDataEmail.required = true;
                }
                else {
                    findMetaDataEmail.required = this.originalEmailMetadata.required;
                }
            }
            this.$emit('update:value', value);
        },
        toggleFullText() {
            this.showFullText = !this.showFullText;
        },
        closeDialog() {
            this.preferredCommunicationError = false;
        },
    },
};
</script>

<style scoped>
.border::v-deep {
    border: 2px solid var(--v-border-metadata-color)!important;
    border-radius: 4px!important;
}
.more-info-chevron {
    flex: none!important;
}
</style>
